import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Volume2, Loader2, Square } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ListenButton({ text, label = "Listen", dark = false, compact = false }) {
  const [state, setState] = useState("idle");
  const audioRef = useRef(null);

  const stop = () => {
    audioRef.current?.pause();
    audioRef.current = null;
    setState("idle");
  };

  const play = async () => {
    if (state === "playing") return stop();
    if (state === "loading") return;
    setState("loading");
    try {
      const res = await axios.post(`${API}/tts`, { text: text.slice(0, 3900) }, { timeout: 90000 });
      const audio = new Audio(`${process.env.REACT_APP_BACKEND_URL}${res.data.url}`);
      audioRef.current = audio;
      audio.onended = () => setState("idle");
      audio.onerror = () => setState("idle");
      await audio.play();
      setState("playing");
    } catch (e) {
      toast.error("Audio unavailable right now.");
      setState("idle");
    }
  };

  const Icon = state === "loading" ? Loader2 : state === "playing" ? Square : Volume2;

  if (compact) {
    return (
      <button
        data-testid="listen-button"
        onClick={play}
        title={label}
        className={`inline-flex items-center justify-center w-8 h-8 rounded-full border transition-colors duration-300 active:scale-95 ${
          dark ? "border-white/25 text-white/70 hover:text-white hover:border-white" : "border-[#C7D8EE] text-[#2563EB] hover:bg-[#EAF2FD]"
        }`}
      >
        <Icon size={14} className={state === "loading" ? "animate-spin" : ""} />
      </button>
    );
  }

  return (
    <button
      data-testid="listen-button"
      onClick={play}
      className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold border transition-all duration-300 active:scale-[0.97] ${
        dark
          ? "border-white/30 text-white hover:bg-white/10"
          : "border-[#BFD4F2] bg-white text-[#1D4ED8] hover:bg-[#EAF2FD] shadow-sm"
      }`}
    >
      <Icon size={16} className={state === "loading" ? "animate-spin" : ""} />
      {state === "playing" ? "Stop" : state === "loading" ? "Loading…" : `${label} ▸`}
    </button>
  );
}
